<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card style="background-color: #1b437c">
            <center>
              <v-card-text>
                <v-avatar color="orange" size="150">
                  <v-img
                    height="100%"
                    src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg"
                  >
                  </v-img>
                  <!-- <span class="white--text text-h5">62</span> -->
                </v-avatar>
              </v-card-text>
            </center>
            <v-divider
              class="mx-4"
              style="background-color: #ffffff"
            ></v-divider>
          </v-card>
          <v-card style="background-color: #1b437c;padding-right: 8px;padding-left: 8px;">
            <v-card-text>
              <v-row>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoRiskAssessment()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoAssessmentHistory()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoCovidCheckHistory()"></v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoVaccinationHistory()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoRegisterCovid()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlComingSoon" @click="GoSignUpForHelp()"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import hourNumber from '../../assets/master/Date/Hour.json'
import minuteNumber from '../../assets/master/Date/Minute.json'
import vaccine from '../../assets/master/vaccine/vaccineName.json'
import categoryName from '../../assets/master/vaccine/categoryName.json'
import axios from 'axios'
import moment from 'moment'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      registerWFHItem: [],
      checkItem: [],
      shifttem: [],
      riskitem: [],
      vaccineItem: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      formUpdate: {
        vaccineName: '',
        vaccineYear: '',
        vaccineMonth: '',
        vaccineDay: '',
        vaccineTime: '',
        hour: '',
        minute: '',
        vaccineCategory: ''
      },
      dialog: false,
      dialogEdit: false,
      dataReady: true,
      hideInfo: true,
      hideCheckinHistory: false,
      hideCheckinRisk: false,
      hideCheckinVaccine: false,
      vaccineCategory: 'บริษัทจัดหา',
      vaccineName: 'ซิโนฟาร์ม',
      year: '',
      month: '',
      day: '',
      hour: 8,
      minute: 30,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      hourNumber: hourNumber,
      minuteNumber: minuteNumber,
      categoryName: categoryName,
      vaccine: vaccine,
      AccessKey: '',
      ApplicationKey: '',
      imageUrl: '',
      imageUrlTeam: '',
      ComingSoon: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    console.log('get_profile')
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.checkLiffLogin()
    this.imageUrlComingSoon = require('@/assets/Icon/ComingSoon.jpg')
    this.imageUrlCheckINOUT = require('@/assets/Icon/CheckINOUT.jpg')
    this.imageUrlReport = require('@/assets/Icon/Report.jpg')
    this.imageUrlRiskAssessment = require('@/assets/Icon/RiskAssessment.jpg')
    console.log('image', this.imageUrl)
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          _this.form.userLinepictureUrl = profileLine.pictureUrl
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
      await _this.getDataEmp(_this.form)
    },
    async getDataEmp (dt) {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            await this.shift_import(response.data[0])
            await this.ch_register_wfh(response.data[0])
            await this.getDataVaccine()
            //
          } else {
            this.$swal(
              'ไม่พบรหัสพนักงาน',
              'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล',
              'error'
            )
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$router.push('/Liff/LoginInfo')
          this.dataReady = true
        })
    },
    registerWFH () {
      this.$router.push('/Liff/RegisterWFH')
    },
    async ch_register_wfh (dt) {
      this.dataReady = false
      this.registerWFHItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/ch_register_wfh/getEmpCode?empCode=" + dt.empCode
        )
        .then(async (response) => {
          console.log('ch_register_wfh', response)
          this.registerWFHItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async shift_import (dt) {
      const today = new Date()
      this.dataReady = false
      this.shifttem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeShiftMonth?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            (today.getMonth() + 1) +
            '&shiftYear=' +
            today.getFullYear()
        )
        .then(async (response) => {
          this.shifttem = response.data
          this.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              var date =
                shifttem.checkInYear +
                '-' +
                shifttem.checkInMonth +
                '-' +
                shifttem.checkInDay
              var startStamp = new Date(
                date + ' ' + shifttem.checkInStartStamp
              )
              var masShiftTypeStartTime = new Date(
                date + ' ' + shifttem.masShiftTypeStartTime
              )

              var checkInStartStampArray = shifttem.checkInStartStamp.split(':')
              shifttem.checkInStartStamp = checkInStartStampArray[0].toString().padStart(2, 0) + ':' + checkInStartStampArray[1].toString().padStart(2, 0)

              var timeAssignArray = shifttem.time_as.split(':')
              // console.log(timeAssignArray)
              shifttem.time_as = timeAssignArray[0] + ':' + timeAssignArray[1]

              if (startStamp > masShiftTypeStartTime) {
                shifttem.colorin = 'red'
              } else {
                shifttem.colorin = 'green'
              }

              if (shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = shifttem.checkInEndStamp
                shifttem.colorout = 'green'
              } else {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }
            } else {
              shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
              shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
              shifttem.colorin = '-'
              shifttem.colorout = '-'
            }
          })
          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async approve () {
      console.log(this.hour)
      console.log(this.minute)
      let ds = {
        empCode: this.profile.empCode,
        vaccineName: this.vaccineName,
        vaccineCategory: this.vaccineCategory,
        vaccineYear: this.year,
        vaccineMonth: this.getMonthThToINT(this.month),
        vaccineDay: this.day,
        vaccineTime: this.hour + ':' + this.minute
      }
      console.log(ds)
      this.addData(ds)
    },
    async addData (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/add",
          ds
        )
        .then(async (response) => {
          console.log(response)
          this.getDataVaccine()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async getDataById (ds) {
      this.dialogEdit = true
      this.formUpdate = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/getID?vaccineId=" + ds.vaccineId
        )
        .then(async (response) => {
          console.log(response.data)
          const vc = response.data.vaccineTime.split(':')
          console.log(vc)
          this.formUpdate = response.data
          this.formUpdate.vaccineMonth = this.getMonthINTToTH(
            this.formUpdate.vaccineMonth
          )
          this.formUpdate.hour = Number(vc[0])
          this.formUpdate.minute = Number(vc[1])
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async edit (ds) {
      console.log(ds)

      let dt = {
        vaccineName: this.formUpdate.vaccineName,
        vaccineCategory: this.formUpdate.vaccineCategory,
        vaccineYear: this.formUpdate.vaccineYear,
        vaccineMonth: this.getMonthThToINT(this.formUpdate.vaccineMonth),
        vaccineDay: this.formUpdate.day,
        vaccineTime: this.formUpdate.hour + ':' + this.formUpdate.minute
      }
      console.log(ds)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/edit/" + ds.vaccineId,
          dt
        )
        .then(async (response) => {
          console.log(response)
          this.getDataVaccine()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async getDataVaccine () {
      this.dataReady = false
      this.dataExportItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/get?empCode=" + this.profile.empCode
        )
        .then(async (response) => {
          this.vaccineItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    openInfo () {
      this.hideInfo = true
      this.hideCheckinHistory = false
      this.hideCheckinRisk = false
      this.hideCheckinVaccine = false
    },
    openCheckInHistory () {
      this.hideInfo = false
      this.hideCheckinHistory = true
      this.hideCheckinRisk = false
      this.hideCheckinVaccine = false
    },
    openCheckRisk () {
      this.hideInfo = false
      this.hideCheckinHistory = false
      this.hideCheckinRisk = true
      this.hideCheckinVaccine = false
    },
    openCheckVaccine () {
      this.hideInfo = false
      this.hideCheckinHistory = false
      this.hideCheckinRisk = false
      this.hideCheckinVaccine = true
    },
    GoRiskAssessment () {
      this.$router.push('/Liff/RiskAssessment')
    },
    GoAssessmentHistory () {
      this.$router.push('/Liff/AssessmentHistory')
    },
    GoCovidCheckHistory () {
      this.$router.push('/Liff/CovidCheckHistory')
    },
    GoVaccinationHistory () {
      this.$router.push('/Liff/VaccinationHistory')
    },
    GoRegisterCovid () {
      this.$router.push('/Liff/RegisterCovid')
    },
    GoSignUpForHelp () {
      this.$router.push('/Liff/SignUpForHelp')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/MenuCovid.vue